import Collection from '../../ModelBinding/Collection';
import Equipement from './Equipment';

export default class EquipmentCollection extends Collection<Equipement> {
  static getModel() {
    return Equipement;
  }

  get camerasCollection() {
    const cameras: Equipement[] = [];
    this.forEach(camera => {
      if (
        !cameras.find(({ id }) => id === camera.id) &&
        (camera.type === 'video_camera' || camera.type === 'camera')
      ) {
        cameras.push(camera);
      }
    });

    return new EquipmentCollection({
      data: cameras.map(camera => camera.jsonSerialize()),
    });
  }

  get dronesCollection() {
    const drones: Equipement[] = [];
    this.forEach(drone => {
      if (
        !drones.find(({ id }) => id === drone.id) &&
        drone.type === 'drone'
      ) {
        drones.push(drone);
      }
    });

    return new EquipmentCollection({
      data: drones.map(drone => drone.jsonSerialize()),
    });
  }

  get equipmentCollection() {
    const equipment: Equipement[] = [];
    this.forEach(item => {
      if (
        !equipment.find(({ id }) => id === item.id) &&
        item.type !== 'accessory' &&
        item.type !== 'lens'
      ) {
        equipment.push(item);
      }
    });

    return new EquipmentCollection({
      data: equipment.map(equipment => equipment.jsonSerialize()),
    });
  }

  get lensCollection() {
    const lenses: Equipement[] = [];
    this.forEach(item => {
      if (!lenses.find(({ id }) => id === item.id) && item.type === 'lens') {
        lenses.push(item);
      }
    });

    return new EquipmentCollection({
      data: lenses.map(lenses => lenses.jsonSerialize()),
    });
  }

  get accessoryCollection() {
    const accessories: Equipement[] = [];
    this.forEach(item => {
      if (!accessories.find(({ id }) => id === item.id) && item.type === 'accessory') {
        accessories.push(item);
      }
    });

    return new EquipmentCollection({
      data: accessories.map(accessories => accessories.jsonSerialize()),
    });
  }
}
